import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Form,
  Modal,
  Row,
  Spinner,
  Col,
} from "react-bootstrap";
import { TableHead, TableRow, TableCell, TextField } from "@mui/material";
import { TableBody } from "semantic-ui-react";
import { TermService } from "../../../service/user_management/terms_conditions.service";

function ManagePaymentAcceptTerms() {
  const [isTableDataLoading, setIsTableDataLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [paymentAcceptTerms, setPaymentAcceptTerms] = useState([]);
  const [allUserLanguages, setAllUserLanguages] = useState([]);

  const [updateAcceptTermsModal, setUpdateAcceptTermsModal] = useState(false);

  const [languageId, setLanguageId] = useState("");
  const [content, setContent] = useState("");
  const [selectedTerm, setSelectedTerm] = useState(null);

  useEffect(() => {
    getAllPaymentAcceptTerms();
    getAllUserLanguages();
  }, []);

  /* ================= API CALLS ================= */

  const getAllPaymentAcceptTerms = async () => {
    try {
      setIsTableDataLoading(true);
      const res = await TermService.PaymentTermsGetAll();
      setPaymentAcceptTerms(res?.data?.PaymentTermsConditions || []);
    } catch (error) {
      console.error("Error fetching payment accept terms:", error);
    } finally {
      setIsTableDataLoading(false);
    }
  };

  const getAllUserLanguages = async () => {
    try {
      const res = await TermService.LanguageGetAll();
      setAllUserLanguages(res?.data?.languages || []);
    } catch (error) {
      console.error("Error fetching languages:", error);
    }
  };

  /* ================= HELPERS ================= */

  const getUserLanguage = (language_id) => {
    const lang = allUserLanguages.find(
      (l) => l.language_id === language_id
    );
    return lang?.language || "N/A";
  };

  /* ================= MODAL ================= */

  const toggleUpdatePaymentAcceptTermsModal = (term = null) => {
    if (term) {
      setSelectedTerm(term);
      setLanguageId(term.language_id);
      setContent(term.content);
    }
    setUpdateAcceptTermsModal(!updateAcceptTermsModal);
  };

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      const obj ={
        term_condition_id:selectedTerm.term_condition_id,
        language_id:languageId,
        content:content
      }

      // Example update call (change API if needed)
      await TermService.PaymentTermsUpdate(obj);

      toggleUpdatePaymentAcceptTermsModal();
      getAllPaymentAcceptTerms();
    } catch (error) {
      console.error("Save failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  /* ================= RENDER ================= */

  return (
    <div>
      {isTableDataLoading ? (
        <div
          className="loading-container"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "90vh",
          }}
        >
          <Spinner animation="border" />
        </div>
      ) : (
        <div style={{ width: "80vw", height: "90vh", overflow: "auto" }}>
          <Table bordered hover>
            <TableHead>
              <TableRow>
                <TableCell>Language</TableCell>
                <TableCell>Privacy Policy & Terms Content</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {paymentAcceptTerms.length > 0 ? (
                paymentAcceptTerms.map((p) => (
                  <TableRow key={p.term_condition_id}>
                    <TableCell>{getUserLanguage(p.language_id)}</TableCell>
                    <TableCell>{p.content}</TableCell>
                    <TableCell align="right">
                      <Button
                        size="sm"
                        onClick={() =>
                          toggleUpdatePaymentAcceptTermsModal(p)
                        }
                      >
                        Edit
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    No Privacy Policy & Terms available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      )}

      {/* ================= MODAL ================= */}

      <Modal
        size="lg"
        centered
        show={updateAcceptTermsModal}
        onHide={() => toggleUpdatePaymentAcceptTermsModal()}
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Privacy Policy & Terms</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {isLoading ? (
            <div className="text-center">
              <Spinner animation="border" />
            </div>
          ) : (
            <Form>
              <Row className="mb-4">
                <Form.Group as={Col} md={6}>
                  <Form.Label>Select Language</Form.Label>
                  <Form.Select
                    value={languageId}
                    onChange={(e) => setLanguageId(e.target.value)}
                  >
                    <option value="">Select</option>
                    {allUserLanguages.map((lang) => (
                      <option
                        key={lang.language_id}
                        value={lang.language_id}
                      >
                        {lang.language}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Row>

              <Row>
                <Form.Group as={Col}>
                  <TextField
                    fullWidth
                    multiline
                    rows={10}
                    label="Content"
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                  />
                </Form.Group>
              </Row>
            </Form>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={handleSubmit}>
            Save
          </Button>
          <Button
            variant="secondary"
            onClick={() => toggleUpdatePaymentAcceptTermsModal()}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ManagePaymentAcceptTerms;
